// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1Nw3k","right":"styles_right__22uwv"};